/**
 * Требования к IAM-операциям (поле name из GetUserPermissions / allPermissionsExampleData.json)
 * для подключения SPA-модулей Pokolenie. Достаточно любой операции из anyOf.
 * Пакетные модули Seedkit (administration, files, …) не перечислены — ими управляет ядро.
 */
export const POKOLENIE_MODULE_SLUGS = [
  'about',
  'advertising',
  'analytics',
  'calendar',
  'content',
  'donation-registry',
  'events',
  'exercises',
  'gamification',
  'good-deeds-board',
  'grants',
  'measures',
  'presentation',
  'press-center',
  'tasks',
  'technical-support',
  'wards-and-volunteers',
] as const;

export type PokolenieModuleSlug = typeof POKOLENIE_MODULE_SLUGS[number];

export type ModuleAccessRule = {
  /** Хотя бы одна из перечисленных IAM-операций */
  anyOf: string[];
};

export const POKOLENIE_MODULE_ACCESS: Record<PokolenieModuleSlug, ModuleAccessRule> = {
  about: { anyOf: [ 'GetAboutMainQuery', 'GetAboutAchievementsQuery' ] },
  advertising: { anyOf: [ 'GetBannersQuery' ] },
  analytics: { anyOf: [ 'GetAdminAnalyticsQuery', 'GetAdminAnalyticsReportsQuery' ] },
  calendar: { anyOf: [ 'GetCalendarMonthQuery' ] },
  content: { anyOf: [ 'GetBannersQuery', 'CreateBannerCommand' ] },
  'donation-registry': { anyOf: [ 'GetDonationsQuery', 'GetDonationByIdQuery' ] },
  events: { anyOf: [ 'GetEventsQuery', 'CreateEventCommand' ] },
  exercises: { anyOf: [ 'GetExercisesQuery', 'CreateExerciseCommand' ] },
  gamification: { anyOf: [ 'GetGamificationTasksQuery', 'GetGamificationProfileQuery' ] },
  'good-deeds-board': { anyOf: [ 'GetGoodDeedsQuery', 'CreateGoodDeedCommand', 'GetAdminGoodDeedsQuery' ] },
  grants: { anyOf: [ 'GetGrantsQuery', 'GetGrantByIdQuery' ] },
  measures: { anyOf: [ 'GetMeasuresQuery', 'GetProjectsQuery', 'GetPublicMeasuresQuery' ] },
  /** В каталоге прав пока нет отдельных операций презентации — доступ при любой непустой выдаче прав */
  presentation: { anyOf: [] },
  'press-center': { anyOf: [ 'GetFundNewsQuery', 'GetAdminFundNewsQuery', 'GetFundNewsByIdQuery' ] },
  tasks: { anyOf: [ 'GetTasksQuery', 'CreateTaskCommand' ] },
  'technical-support': { anyOf: [ 'GetUserSupportsQuery', 'GetUserSupportByIdQuery' ] },
  'wards-and-volunteers': { anyOf: [ 'GetVolunteerApplicationsQuery', 'RegisterWardCommand' ] },
};
